import React from 'react';

import styled from 'styled-components';

import { GroupType } from 'types/groups';

const Container = styled.span`
  display: flex;
  justify-content: center;
  align-content: center;
`;

interface Props {
  item: GroupType;
}

const GroupsTableGroup = ({ item }: Props) => {
  return <Container>{item.active ? <span>🟢</span> : <span>🔴</span>}</Container>;
};

export default GroupsTableGroup;
